import type { IconSvgObject } from './types';

const AirplayIcon: IconSvgObject = [
  ["path", { d: "M19 17H20C21.1046 17 22 16.1046 22 15V5C22 3.89543 21.1046 3 20 3H4C2.89543 3 2 3.89543 2 5V15C2 16.1046 2.89543 17 4 17H5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M16.8145 19.7939L12.8345 15.3716C12.6216 15.1351 12.3183 15 12 15C11.6817 15 11.3784 15.1351 11.1655 15.3716L7.18552 19.7939C7.06608 19.9266 7 20.0988 7 20.2773C7 20.6764 7.32356 21 7.72268 21H16.2773C16.6764 21 17 20.6764 17 20.2773C17 20.0988 16.9339 19.9266 16.8145 19.7939Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default AirplayIcon;
